define(["require", "exports", "./Content"], function (require, exports, Content_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ViewPort = (function () {
        function ViewPort() {
            this.PercentW = 1;
            this.PercentH = 1;
            this.PercentX = 0;
            this.PercentY = 0;
            this.Content = new Content_1.Content();
        }
        return ViewPort;
    }());
    exports.ViewPort = ViewPort;
});
//# sourceMappingURL=ViewPort.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/ViewPort.js
// module id = 152
// module chunks = 0